<template>
    <div :class="['modal_body', classes]" class="px-4 sm:px-6 sm:!max-h-[calc(100vh-240px)]">
        <slot></slot>
    </div>
</template>

<script setup>
const props = defineProps({
    center: {
        type: Boolean,
        default: false,
    },
    classes: {
        type: String,
        default: "",
    },
    isPaddingBottom: {
        type: Boolean,
        default: false,
    },
    isHeader: {
        type: Boolean,
        default: false,
    },
});
</script>

<style scoped>
.modal_body {
    @apply mb-auto flex flex-col overflow-y-auto dark:text-white max-h-[calc(85vh-140px)] xs:max-h-[calc(100vh-265px)] relative flex-auto leading-normal scroll-smooth dark:bg-dm-whitebg;
}
.modal_body.create_modal {
    @apply md:max-h-[calc(100vh-12vh)] !p-0;
}
.modal_body.center {
    @apply justify-center items-center text-center min-h-[15.4375rem] py-10;
}
</style>
